namespace GeniuzPOS.PosShift {
    export interface ReportVatRefundData extends Serenity.ListRequest {
        Details?: ReportVatRefundRow[];
        DatetoDate?: string;
        user?: string;
        username?: string;
        BizName?: string;
        ShopName?: string;
        ShopAddress?: string;
        ShopTaxId?: string;
        BranchName?: string;
    }
}
